module.exports = __webpack_public_path__ + "img/diagram-trapezoid.3c11f6ed.svg";